import { router } from "../router/router.js";
import { contextStore } from "../auth/context-store.js";
import { platform } from "../../app/browser-platform.js";

export default class AdministrationHubPage extends HTMLElement {
  public connectedCallback(): void {
    this.render();
  }

  private render(): void {
    this.innerHTML = `
      <div style="display: flex; flex-direction: column; height: 100%; gap: 24px; background: var(--color-bg-primary); padding: 28px; overflow-y: auto;">
        <header style="border-bottom: 1px solid var(--color-graphite-200); padding-bottom: 16px;">
          <h1 style="color: var(--color-text-muted); font-size: 1.75rem; font-weight: 700; margin: 0;">Módulo de Administração & Cadastros</h1>
          <p style="color: var(--color-text-secondary); font-size: 0.9375rem; margin-top: 6px;">Gestão centralizada de clientes, unidades industriais, governança de acesso, equipes e referências normativas.</p>
        </header>

        <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 20px;">
          <!-- Usuários & Acessos -->
          <div class="admin-card" data-path="/administration/users" style="background: var(--color-surface-primary); border: 1px solid var(--color-graphite-200); border-radius: 10px; padding: 20px; cursor: pointer; transition: all 0.2s; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
            <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px;">
              <div style="background: var(--color-surface-secondary); color: var(--ia-primary); width: 42px; height: 42px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 1.25rem; font-weight: 700;">👥</div>
              <div>
                <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: var(--color-text-muted);">Usuários & Acessos</h3>
                <span style="font-size: 0.75rem; color: var(--color-text-secondary);">Contas e Permissões</span>
              </div>
            </div>
            <p style="color: var(--color-text-secondary); font-size: 0.875rem; margin: 0; line-height: 1.4;">Controle de usuários autorizados, contas de autenticação e atribuições de permissão.</p>
          </div>

          <!-- Empresas & Prestadoras -->
          <div class="admin-card" data-path="/administration/companies" style="background: var(--color-surface-primary); border: 1px solid var(--color-graphite-200); border-radius: 10px; padding: 20px; cursor: pointer; transition: all 0.2s; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
            <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px;">
              <div style="background: var(--color-surface-secondary); color: var(--color-ink); width: 42px; height: 42px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 1.25rem; font-weight: 700;">🏢</div>
              <div>
                <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: var(--color-text-muted);">Empresas & Prestadoras</h3>
                <span style="font-size: 0.75rem; color: var(--color-text-secondary);">Parceiras, Fornecedores e PJs</span>
              </div>
            </div>
            <p style="color: var(--color-text-secondary); font-size: 0.875rem; margin: 0; line-height: 1.4;">Cadastro e homologação de empresas prestadoras de serviço com validação estrita de CNPJ.</p>
          </div>

          <!-- Profissionais & PLH -->
          <div class="admin-card" data-path="/administration/professionals" style="background: var(--color-surface-primary); border: 1px solid var(--color-graphite-200); border-radius: 10px; padding: 20px; cursor: pointer; transition: all 0.2s; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
            <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px;">
              <div style="background: var(--status-danger-bg); color: var(--status-danger-text); width: 42px; height: 42px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 1.25rem; font-weight: 700;"></div>
              <div>
                <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: var(--color-text-muted);">Profissionais & PLH</h3>
                <span style="font-size: 0.75rem; color: var(--color-text-secondary);">Engenheiros, Inspetores e Técnicos</span>
              </div>
            </div>
            <p style="color: var(--color-text-secondary); font-size: 0.875rem; margin: 0; line-height: 1.4;">Cadastro técnico com números oficiais de CREA, CFT, SNQC, SNCC e dados de habilitação.</p>
          </div>

          <!-- Signatários Autorizados -->
          <div class="admin-card" data-path="/administration/signatories" style="background: var(--color-surface-primary); border: 1px solid var(--color-graphite-200); border-radius: 10px; padding: 20px; cursor: pointer; transition: all 0.2s; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
            <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px;">
              <div style="background: rgba(217,70,239,0.15); color: var(--ia-info-fg, #f0abfc); width: 42px; height: 42px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 1.25rem; font-weight: 700;">✍️</div>
              <div>
                <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: var(--color-text-muted);">Signatários Autorizados</h3>
                <span style="font-size: 0.75rem; color: var(--color-text-secondary);">Assinaturas de Laudos & Prontuários</span>
              </div>
            </div>
            <p style="color: var(--color-text-secondary); font-size: 0.875rem; margin: 0; line-height: 1.4;">Profissionais habilitados para firmar pareceres conclusivos e relatórios de integridade.</p>
          </div>

          <!-- Backup & Restauração -->
          <div class="admin-card" data-path="/administration/backup" style="background: var(--color-surface-primary); border: 1px solid var(--color-graphite-200); border-radius: 10px; padding: 20px; cursor: pointer; transition: all 0.2s; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
            <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px;">
              <div style="background: rgba(16, 185, 129, 0.15); color: #10B981; width: 42px; height: 42px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 1.25rem; font-weight: 700;">💾</div>
              <div>
                <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: var(--color-text-muted);">Backup & Restauração</h3>
                <span style="font-size: 0.75rem; color: var(--color-text-secondary);">Exportação, Recuperação & Snapshots</span>
              </div>
            </div>
            <p style="color: var(--color-text-secondary); font-size: 0.875rem; margin: 0; line-height: 1.4;">Ferramenta central de integridade, snapshots automáticos de segurança e importação verificada por SHA-256.</p>
          </div>
        </div>
      </div>
    `;

    this.querySelectorAll(".admin-card").forEach(card => {
      card.addEventListener("click", () => {
        const path = card.getAttribute("data-path");
        if (path) router.navigate(path);
      });
      card.addEventListener("mouseenter", () => {
        (card as HTMLElement).style.borderColor = "var(--color-ink)";
        (card as HTMLElement).style.transform = "translateY(-2px)";
      });
      card.addEventListener("mouseleave", () => {
        (card as HTMLElement).style.borderColor = "var(--color-graphite-200)";
        (card as HTMLElement).style.transform = "translateY(0)";
      });
    });
  }
}

if (!customElements.get("app-administration-hub-page")) {
  customElements.define("app-administration-hub-page", AdministrationHubPage);
}



